import { createContext, useContext } from 'react'

/**
 * Превью рисуется миниатюрой в ленте экранов: без крестика и полоски прогресса —
 * на маленькой карточке они только шумят. Ставит `BlockThumbnail`.
 */
export const PreviewThumbnailContext = createContext(false)

export const useIsPreviewThumbnail = () => useContext(PreviewThumbnailContext)
